import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { GuestSettings } from '../components/GuestSettings';
import { Button } from '../components/Button';
import { Card, CardContent, CardHeader } from '../components/Card';
import { InfoIcon, CheckIcon } from 'lucide-react';
export const BookingDetails = () => {
  const {
    eventId,
    tableId
  } = useParams();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [guestSettings, setGuestSettings] = useState<any>(null);
  // Mock data
  const event = {
    id: eventId,
    title: 'Summer Club Night',
    date: 'Saturday, 15 July 2023',
    time: '22:00 - 05:00'
  };
  const table = {
    id: tableId,
    name: 'VIP Table',
    capacity: 6,
    price: 300,
    minimumSpend: 500
  };
  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    } else {
      navigate(-1);
    }
  };
  const handleSaveSettings = (settings: any) => {
    setGuestSettings(settings);
    setStep(2);
  };
  const handleConfirmBooking = () => {
    navigate(`/booking-confirmation/${eventId}/${tableId}`);
  };
  return <div className="bg-white min-h-screen pb-16" data-id="element-173">
      <Header title="Booking Details" onBack={handleBack} data-id="element-174" />
      <div className="p-4" data-id="element-175">
        <Card className="mb-4" data-id="element-176">
          <CardHeader title={event.title} data-id="element-177" />
          <CardContent data-id="element-178">
            <div className="text-sm text-gray-700" data-id="element-179">
              <p data-id="element-180">{event.date}</p>
              <p data-id="element-181">{event.time}</p>
              <div className="mt-2 pt-2 border-t border-gray-200" data-id="element-182">
                <p className="font-medium" data-id="element-183">{table.name}</p>
                <p data-id="element-184">Capacity: {table.capacity} people</p>
                <p data-id="element-185">Price: {table.price}€</p>
                {table.minimumSpend && <p data-id="element-186">Minimum spend: {table.minimumSpend}€</p>}
              </div>
            </div>
          </CardContent>
        </Card>
        {step === 1 && <>
            <h2 className="text-lg font-bold text-gray-800 mb-3" data-id="element-187">
              Guest Settings
            </h2>
            <p className="text-sm text-gray-600 mb-4" data-id="element-188">
              Define who can join your table and how costs will be shared.
            </p>
            <GuestSettings onSave={handleSaveSettings} data-id="element-189" />
          </>}
        {step === 2 && guestSettings && <>
            <h2 className="text-lg font-bold text-gray-800 mb-3" data-id="element-190">
              Confirm Booking
            </h2>
            <div className="border border-dashed border-gray-300 rounded-lg p-4 mb-4" data-id="element-191">
              <h3 className="font-medium text-gray-800 mb-2" data-id="element-192">
                Your Booking Summary
              </h3>
              <div className="mb-3" data-id="element-193">
                <div className="flex items-center mb-1" data-id="element-194">
                  <CheckIcon className="h-4 w-4 mr-2 text-gray-700" data-id="element-195" />
                  <p className="text-sm text-gray-700" data-id="element-196">
                    You + {guestSettings.ownGuests} friends
                  </p>
                </div>
                {guestSettings.additionalSpots > 0 && <>
                    <div className="flex items-center mb-1" data-id="element-197">
                      <CheckIcon className="h-4 w-4 mr-2 text-gray-700" data-id="element-198" />
                      <p className="text-sm text-gray-700" data-id="element-199">
                        {guestSettings.additionalSpots} additional spots open
                        for others
                      </p>
                    </div>
                    <div className="ml-6 mb-1" data-id="element-200">
                      <p className="text-sm text-gray-700" data-id="element-201">
                        {guestSettings.maleSpots} male /{' '}
                        {guestSettings.femaleSpots} female /{' '}
                        {guestSettings.anySpots} any
                      </p>
                    </div>
                    <div className="flex items-center" data-id="element-202">
                      <CheckIcon className="h-4 w-4 mr-2 text-gray-700" data-id="element-203" />
                      <p className="text-sm text-gray-700" data-id="element-204">
                        Cost sharing:{' '}
                        {guestSettings.costSharing === 'split' ? 'Split between guests' : 'You host (you pay all)'}
                      </p>
                    </div>
                  </>}
              </div>
              <div className="bg-gray-100 p-3 rounded-md" data-id="element-205">
                <h4 className="font-medium text-gray-800 mb-1" data-id="element-206">
                  Payment Details
                </h4>
                <p className="text-sm text-gray-700" data-id="element-207">Total: {table.price}€</p>
                <p className="text-sm text-gray-700" data-id="element-208">Due now: {table.price}€</p>
                <div className="flex items-start mt-2 text-xs text-gray-600" data-id="element-209">
                  <InfoIcon className="h-3 w-3 mr-1 mt-0.5 flex-shrink-0" data-id="element-210" />
                  <p data-id="element-211">Payment will be processed securely via Stripe.</p>
                </div>
              </div>
            </div>
            <Button onClick={handleConfirmBooking} className="w-full" data-id="element-212">
              Confirm & Pay
            </Button>
          </>}
      </div>
      <Navigation data-id="element-213" />
    </div>;
};